import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import { fromJS } from 'immutable';
import createHistory from 'history/createBrowserHistory';
import rootReducer from './modules/index';
//import rootSaga from './modules/sagas';

const sagaMiddleware = createSagaMiddleware();
export const history = createHistory();

const initialState = {};
const middleware = [
  sagaMiddleware,
  routerMiddleware(history)
];
const enhancers = [
  applyMiddleware(...middleware)
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(
  rootReducer,
  fromJS(initialState),
  composedEnhancers
);
//sagaMiddleware.run(rootSaga);

export default store;